<div class="row" *ngIf="propertyList.length > 0">
      <swiper [slidesPerView]="4" [config]="swiperOp" [spaceBetween]="30" (slideChange)="onSlideChange()">
    <ng-template swiperSlide *ngFor="let propertyData of propertyList">
      <app-common-featured-property 
        [propertyData]='propertyData'>
      </app-common-featured-property>
    </ng-template>
  </swiper>
</div>
